<template>
    <div>
        <v-row dense  v-for="itm in items" :key="itm.id">
            <v-col>
                <card-report :item="itm" @callSetDialog="setDialog" />
            </v-col>
        </v-row>

        <!-- Dialog visit -->
        <v-dialog 
            class="d-print-none"
            v-if="item && item != ''"
            v-model="dialog" 
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-system-bar
                class="d-print-none"
                dark
                color="primary"
                height="10px"
            >    
            </v-system-bar>   
 
            <v-card class="background">
            <v-card elevation="0">
                <v-row dense>
                    <v-col cols="12" md="6" sm="12">
                        <v-card-title class="text-h5 d-print-none">
                            <span v-if="item.codigo">Código {{item.codigo}}</span>
                            <span class="ml-4">
                                <v-chip
                                    :color="item.status | statusProposal"
                                    label
                                    text-color="black"
                                    class="font-weight-medium text-h7"
                                >
                                    {{ item.status }}
                                </v-chip> 
                            </span>
                        </v-card-title>
                    </v-col>

                    <v-col cols="12" md="6" sm="12">
                        <v-card-text class="text-right">
                        <v-btn 
                            v-if="me.profile == 'Master' || me.profile == 'Gerente'"
                            :class="$css_button + ' ma-2'" 
                            outlined 
                            @click.prevent="editItem(item.id)"
                            :block="$vuetify.breakpoint.smAndDown"
                        >
                            <v-icon left>mdi-pencil</v-icon> Editar
                        </v-btn>
                        
                        <v-btn
                            dark
                            color="secondary"
                            @click="proposal_pdf()"
                            :class="$css_button + ' ma-2'"
                            :block="$vuetify.breakpoint.smAndDown"
                        >
                            PDF proponente
                        </v-btn>

                        <v-btn
                            dark
                            color="secondary"
                            @click="proposal_pdf('property_owners')"
                            :class="$css_button + ' ma-2'"
                            :block="$vuetify.breakpoint.smAndDown"
                        >
                            PDF Proprietário
                        </v-btn>

                        <v-btn icon @click="openCloseDialog()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        </v-card-text>
                    </v-col>    
                </v-row>
            </v-card>    

                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-card class="pa-4">
                                <main-show :object="item" />
                            </v-card>
                        </v-col>  
                    </v-row>     
                </v-container>
            </v-card>   
        </v-dialog>
        <!-- End Dialog -->
    </div>
</template>

<script>
import CardReport from './CardReport.vue'
import MainShow from './MainShow.vue'

export default {
    components: {
        CardReport,
        MainShow
    },

    props: {
        items: {
            type: Array, // Adicione o tipo
            required: false, // Corrigido: "required" em vez de "require"
            default: () => [] // Adicione um valor padrão para arrays
        },
    },

    computed: {
        me () {
          return this.$store.state.auth.me
        }
    },

    data () {
        return {
            item: {},
            dialog: false,
            module: ''
        }
    },

    methods: {
        openCloseDialog(){
            this.dialog = !this.dialog;
            if(!this.dialog){
                this.module = '';
            }
        },

        setDialog(params){
            this.module = params.module;
            switch (this.module) {
                case 'showitem':
                    this.showItem(params.item)
                    break                                        
                default:
                    console.log('Ação não reconhecida')
                    break
            }
        },

        showItem(item){
            this.item = item; 
            this.dialog = true;
        },

        proposal_pdf(target = null){
            const params = {};
            params.id = this.item.id;
            params.file_name = 'Proposta - codigo ' + this.item.codigo + '.pdf';
            params.target = target;

            this.$store.dispatch('proposal_pdf', params) 
                        .then(response => {
                           this.$snotify.success('Download em andamento');
                        })
            
        },

        editItem(id){
            this.dialog = false;
            this.$router.push({
                name: 'admin.proposals.edit',
                params: { id: id }
            });
        }
    }
}
</script>
